import { Vue } from 'vue-class-component';
import { Inject, Options, Prop } from 'vue-property-decorator';
import AccountInfoPanel from '@/components/header/account-info-panel/index.vue';
import { RouteN } from '@/constants/route-name';
import AlertBox from '../../alert-box/index.vue';
import { EventEmitter } from 'events';

@Options({
  components: {
    AccountInfoPanel,
    AlertBox
  }
})
export default class PageHeader extends Vue {

  @Prop({default: false})
  private showAppMenu!: boolean;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private showCancelAlertBox = false;

  mounted() {
    this.eventCtrl.on('cancel-eoi-apply-clicked', this.closeButtonClicked);
  }


  beforeUnmount() {
    this.eventCtrl.removeListener('cancel-eoi-apply-clicked', this.closeButtonClicked);
  }

  private logoClick() {
    if (this.$route.name == 'EoiApply' && !this.isConfirmationPage)  {
      this.showCancelAlertBox = true;
    } else {
      this.exitApplication();
    }
  }

  private backToDashboard(): void {
    this.$router.push({ name: RouteN.CMP.Dashboard.n });
  }

  private exitApplication() {
    this.showCancelAlertBox = false;
    // TODO
    // clear all application data
    window.sessionStorage.removeItem('eoiPageSection');
    this.$router.push({ name: RouteN.CMP.Dashboard.n });
  }

  private closeButtonClicked() {
    if (this.isConfirmationPage) {
      this.exitApplication();
    } else {
      this.showCancelAlertBox = true;
    }
  }

  get isConfirmationPage(): boolean{
    const section: string = this.$route.query.sec as string || '';
    return section.indexOf('confirmation') > -1;
  }


}

